<div class="card">
  @if (showHeader) {
    <div
      [class.error]="showErrorHeader"
      [class.intermediateSuccess]="showHeaderIntermediateSuccess"
      [class.overdue2]="showReopenRequestHeader"
      [class.overdue]="showHeaderOverdue"
      [class.rejection]="showHeaderRejection"
      [class.success]="showHeaderSuccess"
      [class.warning]="showWarningHeader"
      [ngStyle]="{ 'min-height.px': headerHeight }"
      class="header">
      <div
        *ngIf="visibleActionButtons && visibleActionButtons.length > 0"
        class="actions">
        <app-icon-button
          (buttonClicked)="button.fn()"
          *ngFor="let button of visibleActionButtons"
          [icon]="button.icon"
          [label]="button.name"
          class="d-inline-block">
        </app-icon-button>
      </div>
      <div *ngIf="title" class="me-2">
        <h1>{{ title }}</h1>
      </div>
      <div *ngIf="context" class="me-2">
        <h2>({{ context }})</h2>
      </div>
      <ng-container>
        <div class="column card-controls-divider">
          <ng-content select="[cardCustomHeader]"></ng-content>
        </div>
      </ng-container>
      <ng-container *ngFor="let buttonWithInfo of buttonsWithLabels">
        <div class="column card-controls-divider">
          <app-button-panel
            [buttons]="[buttonWithInfo.button]"></app-button-panel>
          <ng-container
            *ngFor="
              let info of buttonWithInfo.informationLabels;
              let i = index;
              let even = even
            ">
            <div *ngIf="even" class="follow-up-section-labels ms-3">
              <div class="follow-up-label">
                <small class="me-1">
                  <b>{{ info.label }} </b>
                </small>
                <app-icon
                  *ngIf="info.tooltip?.length > 0"
                  [name]="info.iconName"
                  [ngbTooltip]="info.tooltip"
                  class="mt-1 ml-1"
                  placement="{{ info.placement ?? 'bottom' }}"></app-icon>
              </div>
              <div
                *ngIf="buttonWithInfo.informationLabels.length >= i + 2"
                class="follow-up-label">
                <small class="me-1">
                  <b>{{ buttonWithInfo.informationLabels[i + 1].label }}</b>
                </small>
                <app-icon
                  *ngIf="
                    buttonWithInfo.informationLabels[i + 1].tooltip?.length > 0
                  "
                  [name]="buttonWithInfo.informationLabels[i + 1].iconName"
                  [ngbTooltip]="buttonWithInfo.informationLabels[i + 1].tooltip"
                  class="mt-1 ml-1"
                  placement="{{
                    buttonWithInfo.informationLabels[i + 1].placement ??
                      'bottom'
                  }}"></app-icon>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <ng-container
        *ngFor="let info of informationLabels; let i = index; let even = even">
        <div *ngIf="even" class="follow-up-section-labels ms-3">
          <div class="follow-up-label">
            <small
              ><b>{{ info }} </b></small
            >
          </div>
          <div
            *ngIf="informationLabels.length >= i + 2"
            class="follow-up-label">
            <small
              ><b>{{ informationLabels[i + 1] }}</b></small
            >
          </div>
        </div>
      </ng-container>
      <div class="button-panels">
        <div *ngIf="informationBlocks && informationBlocks.length > 0">
          <div class="information-blocks">
            @for (block of informationBlocks; track block) {
              <div class="information-block" [class]="block.style">
                {{ block.content }}
              </div>
            }
          </div>
        </div>
        <div
          *ngIf="visibleButtons && visibleButtons.length > 0"
          class="buttons">
          <app-button-panel [buttons]="visibleButtons"></app-button-panel>
        </div>
        <div
          *ngIf="visibleDropdownOptions && visibleDropdownOptions.length > 0"
          class="buttons">
          <div class="d-inline-block" container="body" ngbDropdown>
            <button
              [class.btn-primary]="
                !hasHighlightedDropdownOptions() &&
                !hasSecondaryHighlightedDropdownOptions()
              "
              [class.btn-secondarySuccess]="
                hasSecondaryHighlightedDropdownOptions() &&
                !hasHighlightedDropdownOptions()
              "
              [class.btn-success]="hasHighlightedDropdownOptions()"
              class="btn"
              ngbDropdownToggle>
              Actions
            </button>
            <div class="ontop" ngbDropdownMenu>
              <ng-container *ngFor="let action of visibleDropdownOptions">
                <div
                  [class.highlightedSecondary]="action.isSecondaryHighlighted"
                  [class.highlighted]="action.isHighlighted">
                  <button
                    (click)="action.fn()"
                    [disabled]="!action.isEnabled"
                    ngbDropdownItem>
                    {{ action.name }}
                  </button>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
